import { ReactNode } from 'react'

import { InfoValue } from './styles'

interface IValueProps {
  children: ReactNode
}

export function Value({ children }: IValueProps) {
  return <InfoValue>{children}</InfoValue>
}
